import { createSlice } from '@reduxjs/toolkit'

import i18n from 'i18n'
import { LanguageCode } from 'meta/app/translate'
import { initialState } from 'store/pages/collection/state'

import { getCollectionKey } from '../_utils'
import { getActiveEvents } from '../actions/getActiveEvents'
import { getActiveTypeticketcollections } from '../actions/getActiveTypeticketcollections'
import { getBulkData } from '../actions/getBulkData'
import { getData } from '../actions/getData'
import { getEvents } from '../actions/getEvents'

export const CollectionSlice = createSlice({
  name: 'collection',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, action) => {
      const { collectionId, data } = action.payload

      const language = (i18n?.language?.substring(0, 2) as LanguageCode) ?? LanguageCode.it
      const path = getCollectionKey({ id: collectionId, language })

      state[path] = { ...state[path], details: data }
    })

    builder.addCase(getBulkData.fulfilled, (state, action) => {
      const data = action.payload

      const language = (i18n?.language?.substring(0, 2) as LanguageCode) ?? LanguageCode.it

      data.forEach((collection) => {
        const idPath = getCollectionKey({ id: String(collection.id), language })
        const codePath = getCollectionKey({ id: collection.code, language })
        const codeUrlPath = getCollectionKey({ id: collection.codeUrl, language })

        state[idPath] = { ...state[idPath], details: collection }
        state[codePath] = { ...state[codePath], details: collection }
        state[codeUrlPath] = { ...state[codeUrlPath], details: collection }
      })
    })

    builder.addCase(getEvents.fulfilled, (state, action) => {
      const { collectionId, data, metadata } = action.payload

      const language = (i18n?.language?.substring(0, 2) as LanguageCode) ?? LanguageCode.it
      const path = getCollectionKey({ id: collectionId, language })

      state[path] = {
        ...state[path],
        events: {
          data: {
            ...state[path]?.events?.data,
            [metadata.page]: data,
          },
          metadata,
        },
      }
    })
    builder.addCase(getActiveEvents.fulfilled, (state, action) => {
      const { collectionId, data, metadata } = action.payload

      const language = (i18n?.language?.substring(0, 2) as LanguageCode) ?? LanguageCode.it
      const path = getCollectionKey({ id: collectionId, language })

      state[path] = {
        ...state[path],
        activeEvents: {
          data: {
            ...state[path]?.activeEvents?.data,
            [metadata.page]: data,
          },
          metadata,
        },
      }
    })
    builder.addCase(getActiveTypeticketcollections.fulfilled, (state, action) => {
      const { collectionId, data, metadata } = action.payload

      const language = (i18n?.language?.substring(0, 2) as LanguageCode) ?? LanguageCode.it
      const path = getCollectionKey({ id: collectionId, language })

      state[path] = {
        ...state[path],
        activeTypeticketcollections: {
          data: {
            ...state[path]?.activeTypeticketcollections?.data,
            [metadata.page]: data,
          },
          metadata,
        },
      }
    })
  },
})
